import React from 'react';
import SIcon from './SIcon';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faRepeat} fa />;

export default Icon;
